import { render } from "./TrialEnded.vue?vue&type=template&id=074642ae&scoped=true"
import script from "./TrialEnded.vue?vue&type=script&lang=js"
export * from "./TrialEnded.vue?vue&type=script&lang=js"

import "./TrialEnded.vue?vue&type=style&index=0&id=074642ae&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074642ae"]])

export default __exports__